<div class="imgContainer" [ngClass]="{'mobileImgContainer': isMobile}" *ngIf="!showingData.rented">
  <img *ngIf="getMainImg()" [src]="getMainImg()" alt="">
  <img *ngIf="!getMainImg()" src="./assets/img/noImg.png" alt="">
</div>
<div class="imgContainer" [ngClass]="{'mobileImgContainer': isMobile}"  *ngIf="showingData.rented">
<img src="./assets/img/rented.png" alt="">
<div class="rentedImageDataContainer">
  <div class="rentedImageData">
    <img src="./assets/img/noShowings.svg" alt="">
    <div class="rentedImageDataText">
      <div class="rentedImageDataTitle">
        {{'MY_SHOWINGS.RENTAL.TITLE' | translate}}
      </div>
      <div class="rentedImageDataTextBody">
        {{'MY_SHOWINGS.RENTAL.BODY' | translate}}
      </div>
    </div>
  </div>
</div>
</div>
<div class="dataContainer" [ngClass]="{'mobileDataContainer': isMobile && !showingData.rented,'mobileRentedDataContainer': isMobile && showingData.rented}">
<div class="title" [ngClass]="{'mobileRentedTitle': showingData.rented && isMobile}">
  <div [ngClass]="{'titleText': isMobile,'renatlTitleText': isMobile && showingData.rented}">{{showingData?.propertyAddress}}</div>
  <div class="address" *ngIf="!showingData.rented">{{showingData?.propertyData?.city}}, {{showingData?.propertyData?.zipCode}}</div>
  <div class="rentedTag" *ngIf="showingData.rented && isMobile">
    {{'MY_SHOWINGS.RENTAL.RENTED_TAG' | translate}}
  </div>
</div>
<div class="link" (click)="maps()" [ngClass]="{'mobileLink': isMobile}" *ngIf="!showingData.rented">
  {{'MY_SHOWINGS.GET_DIRECTIONS_TEXT' | translate}}
</div>
<div class="data" [ngClass]="{'mobileData': isMobile}" *ngIf="!showingData.rented">
  <div class="dataItem">
    <i class="fa-light fa-bed dataIcon"></i> <span *ngIf="showingData?.propertyData?.rooms">{{showingData?.propertyData?.rooms}}</span>  <span *ngIf="!showingData?.propertyData?.rooms">NA</span>
  </div>
  <div class="dataItem">
    <i class="fa-light fa-bath dataIcon"></i> <span *ngIf="showingData?.propertyData?.bath">{{showingData?.propertyData?.bath}}</span>  <span *ngIf="!showingData?.propertyData?.bath">NA</span>
  </div>
  <div class="dataItem">
    <i class="fa-light fa-ruler-combined dataIcon"></i> <span *ngIf="showingData?.propertyData?.squareFeet">{{showingData?.propertyData?.squareFeet | number}} ft</span>  <span *ngIf="!showingData?.propertyData?.squareFeet">NA</span>
  </div>
</div>
<div class="dateTime" *ngIf="!showingData.rented">
  <div class="dateTimeItem">
    <div class="dateTimeTitle">
     {{'MY_SHOWINGS.DATE_INPUT' | translate}} 
    </div>
    <div class="dateTimeText">
      {{showingData?.scheduledVisitDate | getTimeDate : 'date' | date : 'MMM dd, yyyy'}}
    </div>
  </div>
  <div class="dateTimeItem">
    <div class="dateTimeTitle">
      {{'MY_SHOWINGS.TIME_INPUT' | translate}} 
    </div>
    <div class="dateTimeText">
      {{showingData?.scheduledVisitDate | getTimeDate : 'time'}}
    </div>
  </div>
</div>
<div class="rentedTag" *ngIf="showingData.rented && !isMobile">
  {{'MY_SHOWINGS.RENTAL.RENTED_TAG' | translate}}
</div>
</div>
<div class="actionContainer" [ngClass]="{'mobileActionContainer': isMobile, 'rentedActionContainer': !isMobile && showingData.rented, 'mobileRentedActionContainer': isMobile && showingData.rented}">
<button *ngIf="!showingData.checkIn && !showingData.rented && !showingData.deletedByCandidate" class="home365-button primary flex center-vr " (click)="check('check-in')">
  {{'MY_SHOWINGS.CHECK_IN_BUTTON' | translate}}
</button>
<button *ngIf="showingData.checkIn && !showingData.checkOut && !showingData.rented && !showingData.deletedByCandidate" class="home365-button primary flex center-vr " (click)="check('check-out')">
  {{'MY_SHOWINGS.CHECK_OUT_BUTTON' | translate}}
</button>
<button *ngIf="showingData.rented" class="home365-button primary flex center-vr " (click)="exploreHomes()">
  {{'MY_SHOWINGS.RENTAL.EXPLORE_HOMES' | translate}}
</button>
<button *ngIf="!showingData.rented"  class="home365-button primary inverted flex center-vr " (click)="apply()">
  {{'MY_SHOWINGS.APPLY_BUTTON' | translate}}
</button>
<div class="linksRow" *ngIf="!showingData.rented">
  <div class="link" (click)="reschedule()"><i class="fa-light fa-calendar dataIcon"></i> {{'MY_SHOWINGS.RESCHEDULE_BUTTON' | translate}}</div>
  <div class="link" (click)="cancel()" *ngIf="!showingData.deletedByCandidate"><i class="fa-light fa-trash-can dataIcon"></i> {{'MY_SHOWINGS.CANCEL_BUTTON' | translate}}</div>
</div>
</div>

